import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import type { PublicSpotImage } from '~pages/Spot/query';

// Native horizontal scroll strip — mirrors the Flutter CarouselView (free
// scroll, rounded slides, next image peeking). No JS/dep: overflow-x + flex
// slides at ~88% width give the peek; proximity snap keeps it from resting mid-image.
export function Carousel({
  images
}: {
  images: PublicSpotImage[];
}) {
  const single = images.length === 1;
  return <div {...stylex.props(styles.viewport)}>
      {images.map(image => <img key={image.id} {...stylex.props(styles.slide, single && styles.slideSingle)} src={image.url} alt="" loading="lazy" />)}
    </div>;
}